import _ from 'lodash'
import {
  curveLinear,
  curveMonotoneX,
  curveBasis,
  curveStep,
  curveStepBefore,
  curveStepAfter
} from 'd3-shape'

export function interpolateTimelineValues(fromObj, toObj, progress) {
  const interpolated = {}
  for (const timestamp in toObj) {
    if (toObj.hasOwnProperty(timestamp)) {
      if (fromObj && fromObj.hasOwnProperty(timestamp)) {
        const fromV = fromObj[timestamp]
        const toV = toObj[timestamp]
        interpolated[timestamp] = {
          y0: fromV.y0 + (toV.y0 - fromV.y0) * progress,
          y1: fromV.y1 + (toV.y1 - fromV.y1) * progress,
          colorValue: fromV.colorValue + (toV.colorValue - fromV.colorValue) * progress,
          timestamp: timestamp,
          value: fromV.value + (toV.value - fromV.value) * progress
        }
      }
      else {
        interpolated[timestamp] = toObj[timestamp]
      }
    }
  }
  return interpolated
}

export const COLORS = {
  RED: '#ff0000',
  ORANGE: '#ff8100',
  YELLOW: '#dbbb47',
  BLUE: '#3ba7db',
  GREEN: '#00b500'
}

export const COLORSET = [
  '#A69F21',
  '#9AA621',
  '#21A662',
  '#5AA69E',
  '#2189A6',
  '#524FA1',
  '#7533A6',
  '#807C40',
  '#798033',
  '#40805F',
  '#458079',
  '#407280',
  '#413F80',
  '#654080',
  '#8C8962',
  '#9FA664',
  '#638C76',
  '#638C87',
  '#6398A6',
  '#64638C',
  '#7B638C',
  '#9FA664',
  '#779183'
]

/**
 * Available axes that a Schema Field may be assigned to
 *  e.g. in schema initialization object
 * {
 *   graphable: {
 *     axis: AXES.X // Will be used in the x-axis by graph types that utilize it
 *   }
 * }
 */
export const GRAPH_AXES = _.mapValues({
  NONE: 1, // No axis assignment
  X: 1,
  Y: 1,
  Z: 1,
  COLOR: 1, // Some graphs support an optional chromatic scale
  RADIUS: 1,
  ANGLE: 1
}, (v, key) => key)

export const GRAPH_STROKE_STYLES = {
  // BASIC: 'BASIC',
  SOLID: 'SOLID',
  DASHED: 'DASHED',
  ANIMATED: 'ANIMATED' // EKG-style cycling draw in left-to-right
  // DASHED_BASIC: 'DASHED_BASIC'
}

export const GRAPH_FILL_STYLES = {
  BASIC: 'BASIC',
  GRADIENT: 'GRADIENT'
}

export const D3_CURVE_INTERPOLATORS = {
  LINEAR: curveLinear,
  MONOTONE: curveMonotoneX, // Preferred
  BASIS: curveBasis,
  STEP: curveStep,
  STEP_BEFORE: curveStepBefore,
  STEP_AFTER: curveStepAfter
}

export const CURVE_OPTIONS = _.mapValues(D3_CURVE_INTERPOLATORS, (v, k) => k)

